module.exports = __webpack_public_path__ + "static/media/oiliness.8bfc4344.svg";